
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slugCoach]/channels",
      function () {
        return require("private-next-pages/coaches/[slugCoach]/channels/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slugCoach]/channels"])
      });
    }
  